"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col space-y-2 items-center md:items-start">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col space-y-3 items-center md:items-start">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.url || item.href || "#"} className="hover:text-primary transition-colors uppercase font-medium text-[14px] tracking-tight">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const businessName = "OntarioCalc";
  return <section data-section-id="254057" id="footer" className="relative bg-background text-foreground pt-12 pb-8">
      <div className="absolute top-0 left-0 w-full">
        <Separator className="bg-border" />
      </div>

      <div className="container mx-auto px-4 max-w-screen-xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 text-center md:text-left text-[14px] font-sans">
          
          {}
          <div className="flex flex-col items-center md:items-start space-y-4">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="text-muted-foreground mt-4 leading-relaxed">
              Precision financial tools for Ontario residents. &copy; {currentYear} {businessName}.<br />
              All rights reserved.
            </p>
            <p className="text-muted-foreground mt-4 leading-relaxed">
              Current rent increase cap: 2.1% (2026). More info <Link to="https://www.ontario.ca/page/residential-rent-increases" className="underline hover:text-primary transition-colors">here</Link>.
            </p>
            <p className="text-muted-foreground mt-4 leading-relaxed">
              TFSA Information <Link to="https://www.canada.ca/en/revenue-agency/services/tax/individuals/topics/tax-free-savings-account.html" newTab className="underline hover:text-primary transition-colors">here</Link>.
            </p>
          </div>

          {}
          <div className="flex flex-col items-center md:items-start space-y-4">
            <h4 className="font-default font-bold uppercase text-foreground mb-2 tracking-wider">Calculators</h4>
            <MenuProvider menu_id="45">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

        </div>
      </div>
    </section>;
}